import React, { useState } from 'react';
import QuizList from './QuizList';
import ManageQuestions from './ManageQuestions';
import UserScores from './UserScores';

type View = 'list' | 'questions' | 'scores';

const QuizManagement = () => {
  const [currentView, setCurrentView] = useState<View>('list');
  const [selectedQuiz, setSelectedQuiz] = useState(null);

  const handleManageQuestions = (quiz) => {
    setSelectedQuiz(quiz);
    setCurrentView('questions');
  };

  const handleViewScores = (quiz) => {
    setSelectedQuiz(quiz);
    setCurrentView('scores');
  };

  const handleBackToList = () => {
    setCurrentView('list');
    setSelectedQuiz(null);
  };

  return (
    <div className="quiz-management-container h-full">
      {currentView === 'list' && (
        <QuizList
          onManageQuestions={handleManageQuestions}
        />
      )}
      {currentView === 'questions' && selectedQuiz && (
        <ManageQuestions
          quiz={selectedQuiz}
          onBack={handleBackToList}
          onViewScores={handleViewScores}
        />
      )}
      {currentView === 'scores' && selectedQuiz && (
        <UserScores
          quiz={selectedQuiz}
          onBack={handleBackToList}
        />
      )}
    </div>
  );
};

export default QuizManagement;
